import React from 'react'
import { ScannedProduct } from './ScanPage'
import { DataTable } from '../../components'
import { OrderItem } from '../../utils/orderApi'
import flatten from '../../utils/flatten'

interface OrderResultsProps {
  traces: ScannedProduct[]
  currentArticleNo: string
  serials: string[][]
  orderItems: OrderItem[]
}

const OrderResults: React.FunctionComponent<OrderResultsProps> = props => {
  const { traces, currentArticleNo, serials, orderItems } = props

  const traceData = traces.map(trace => {
    const { SKU, scannedCount = 0, count } = trace

    const updatedScannedCount = scannedCount + (SKU === currentArticleNo ? flatten(serials, 2).length : 0)

    const updatedCount = orderItems.length > 0 ? `${updatedScannedCount} / ${count}` : count

    return [SKU, updatedCount]
  })

  const tracesSerialsCount = traces
    .map(({ count }) => count)
    .reduce((acc: number, amount: number) => acc + Number(amount), 0)

  return (
    <div className="row animated fadeIn order-fetch-results">
      <div className="col-md-12">
        <DataTable
          heading={
            <>
              {tracesSerialsCount} Serial No's
              <span className="heading-spacer">|</span> Order No: {traces[0].orderNo}
            </>
          }
          columns={[{ title: 'Article Number' }, { title: 'Amount' }]}
          data={traceData}
          showId={true}
        />
      </div>
    </div>
  )
}

export default OrderResults
